import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import i18n from 'i18next';
import { useTranslation } from "react-i18next";
import { Select, DatePicker, Input } from 'antd';
import dayjs from "dayjs";
import { useParams } from "react-router-dom";

import Flex from "../../core/Flex";
import FormTitle from "../../form/FormTitle";
import FormText from "../../form/FormText";
import FormRemark from "../../form/FormRemark";
import Divider from "../../core/Divider";
import Space from "../../core/Space";
import useAdminApplicationDetailStore from "../../../store/useAdminApplicationDetailStore";
import useApplyStore from "../../../store/useApplyStore";
import useAuthAdminStore from "../../../store/useAuthAdminStore";
import withErrorHandling from "../../../function/withErrorHandling";
import useModalStore from "../../../store/useModalStore";

function Details() {
  const { t } = useTranslation();
  const { aid } = useParams();
  const { TextArea } = Input;
  const { data, admUpdatePreAuthForm, admGetPreAuthForm, showSTPWarningModal } = useAdminApplicationDetailStore();
  const { openModalConfirm } = useModalStore();
  const { hospitalList } = useApplyStore();
  const { isCSTeam,role } = useAuthAdminStore();
  const [isEdit_firstvisitdt, setIsEdit_firstvisitdt] = useState(false);
  const [temp_firstvisitdt, setTemp_firstvisitdt] = useState(data?.form?.firstvisitdt);
  const [isEdit_admissiondt, setIsEdit_admissiondt] = useState(false);
  const [temp_admissiondt, setTemp_admissiondt] = useState(data?.form?.admissiondt);
  const [isEdit_hospital, setIsEdit_hospital] = useState(false);
  const [temp_hospital, setTemp_hospital] = useState(data?.form?.hospital);
  const [temp_hospitalid, setTemp_hospitalid] = useState(data?.form?.hospitalid);
  const [isEdit_housingclass, setIsEdit_housingclass] = useState(false);
  const [temp_housingclass, setTemp_housingclass] = useState(data?.form?.housingclass);
  const [isEdit_diagnosis, setIsEdit_diagnosis] = useState(false);
  const [temp_diagnosis, setTemp_diagnosis] = useState(data?.form?.diagnosis);
  const [isEdit_medsigndt, setIsEdit_medsigndt] = useState(false);
  const [temp_medsigndt, setTemp_medsigndt] = useState(data?.form?.medsigndt?.substr(0, 10));
  const [isEdit_Ansthsimthd, setIsEdit_Ansthsimthd] = useState(false);
  const [temp_Ansthsimthd, setTemp_Ansthsimthd] = useState(data?.form?.Ansthsimthd);
  const [isEdit_oprtn, setIsEdit_oprtn] = useState(false);
  const [temp_oprtn, setTemp_oprtn] = useState(data?.form?.oprtn);
  const [isEdit_surgeonfee, setIsEdit_surgeonfee] = useState(false);
  const [temp_surgeonfee, setTemp_surgeonfee] = useState(data?.form?.surgeonfee);
  const [isEdit_anesthesiologistfee, setIsEdit_anesthesiologistfee] = useState(false);
  const [temp_anesthesiologistfee, setTemp_anesthesiologistfee] = useState(data?.form?.anesthesiologistfee);
  const [isEdit_operatingrmfee, setIsEdit_operatingrmfee] = useState(false);
  const [temp_operatingrmfee, setTemp_operatingrmfee] = useState(data?.form?.operatingrmfee);
  const [isEdit_hosmisousfee, setIsEdit_hosmisousfee] = useState(false);
  const [temp_hosmisousfee, setTemp_hosmisousfee] = useState(data?.form?.hosmisousfee);
  const [isEdit_housetourfee, setIsEdit_housetourfee] = useState(false);
  const [temp_housetourfee, setTemp_housetourfee] = useState(data?.form?.housetourfee);
  const [isEdit_noofdays, setIsEdit_noofdays] = useState(false);
  const [temp_noofdays, setTemp_noofdays] = useState(data?.form?.noofdays);
  const [isEdit_surgeryBudgetRemark, setIsEdit_surgeryBudgetRemark] = useState(false);
  const [temp_surgeryBudgetRemark, setTemp_surgeryBudgetRemark] = useState(data?.form?.surgeryBudgetRemark);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
  };

  const loadAdmUpdatePreAuthForm = withErrorHandling(admUpdatePreAuthForm);
  const loadAdmGetPreAuthForm = withErrorHandling(admGetPreAuthForm);

  const getLogValueTranslation = (fieldname, value) => {
    switch (fieldname) {
      case "housingclass":
        switch (value) {
          case "REGULAR":
            return t("translation:apply.step3_1.section3.f4_Option1");

          case "SEMI":
            return t("translation:apply.step3_1.section3.f4_Option2");

          case "PRIVATE":
            return t("translation:apply.step3_1.section3.f4_Option3");

          case "DAYCASE":
            return t("translation:apply.step3_1.section3.f4_Option4");

          case "OUTPATIENT_CLINICAL":
            return t("translation:apply.step3_1.section3.f4_Option5");

          default:
            return value;
        }

      case "Ansthsimthd":
        switch (value) {
          case "NONEED":
            return t("translation:apply.step2_4.section2.Q9_Option1");

          case "PARTIAL":
            return t("translation:apply.step2_4.section2.Q9_Option2");

          case "FULL":
            return t("translation:apply.step2_4.section2.Q9_Option3");

          case "MONITOR":
            return t("translation:apply.step2_4.section2.Q9_Option4");

          case "UNKNOWN":
            return t("translation:apply.step2_4.section2.Q9_Option5");

          default:
            return value;
        }

      default:
        return value;
    }
  }

  const isAllowEditEmail= ['CLMHDR','CLMADM','SUPERADM']?.includes(role);
  const [isEditEmail, setIsEditEmail] = useState(false);
  const [editEmailInfo,setEditEmailInfo]=useState(data?.user?.email);

  return (
    <Flex direction={"column"} alignItems={"flex-start"} gap={24} height={"100%"} width={"100%"} style={{ overflow: "auto" }}>
      <FormTitle>{t("translation:apply.step3_1.section3.title").replace("3. ", "")}</FormTitle>

      <Flex direction={"column"} alignItems={"flex-start"} style={{ gap: 10 }}>

        {
         isAllowEditEmail &&
        <Flex direction={"column"} alignItems={"flex-start"}>
          <FormRemark>{t("common:email")}</FormRemark>
          <Flex>
            {
              isEditEmail ?
                <>
                  <Input value={editEmailInfo} onChange={(e)=>{
                    setEditEmailInfo(e.target.value)
                  }}/>
                  <BtnSave onClick={async () => {
                    setIsEditEmail(false);
                    await loadAdmUpdatePreAuthForm(aid, {
                      "userEmail": editEmailInfo
                    });
                    await loadAdmGetPreAuthForm(aid);
                  }}>
                    <BtnSaveText>Save</BtnSaveText>
                  </BtnSave>
                  <BtnCancel title={"cancel"} onClick={async () => {
                    setIsEditEmail(false);
                    setEditEmailInfo(data?.user?.email)
                   }}>
                    <BtnCancelText>Cancel</BtnCancelText>
                  </BtnCancel>
                </>
                :
                <>
                  <FormText>{data?.user?.email}</FormText>
                  {           
                    <BtnEdit title={"edit"} onClick={() => {
                         setIsEditEmail(true)
                     }}>
                      <Icon24 src={`${process.env.PUBLIC_URL}/images/pen.svg`} alt="edit" />
                    </BtnEdit>
                  }
                </>
            }
          </Flex>
        </Flex>   
        } 

        <Flex direction={"column"} alignItems={"flex-start"}>
          <FormRemark>{t("translation:apply.step3_1.section3.f1")}</FormRemark>
          <Flex>
            {
              isEdit_firstvisitdt ?
                <>
                  <DatePicker
                    value={temp_firstvisitdt ? dayjs(temp_firstvisitdt) : null}
                    placeholder="YYYY-MM-DD"
                    onChange={(date, dateString) => {
                      setTemp_firstvisitdt(dateString);
                    }}
                  />
                  <BtnSave onClick={async () => {
                    setIsEdit_firstvisitdt(false);
                    await loadAdmUpdatePreAuthForm(aid, {
                      "firstvisitdt": temp_firstvisitdt
                    });
                    await loadAdmGetPreAuthForm(aid);
                  }}>
                    <BtnSaveText>Save</BtnSaveText>
                  </BtnSave>
                  <BtnCancel title={"cancel"} onClick={async () => {
                    setIsEdit_firstvisitdt(false);
                    setTemp_firstvisitdt(data?.form?.firstvisitdt);
                  }}>
                    <BtnCancelText>Cancel</BtnCancelText>
                  </BtnCancel>
                </>
                :
                <>
                  <FormText>{data?.form?.firstvisitdt}</FormText>
                  {
                    !isCSTeam() &&
                    <BtnEdit title={"edit"} onClick={() => {
                      showSTPWarningModal(() => {
                        setIsEdit_firstvisitdt(true)
                      });
                    }}>
                      <Icon24 src={`${process.env.PUBLIC_URL}/images/pen.svg`} alt="edit" />
                    </BtnEdit>
                  }
                </>
            }
          </Flex>
        </Flex>

        <Flex direction={"column"} alignItems={"flex-start"}>
          <FormRemark>{t("translation:apply.step3_1.section3.f2")}</FormRemark>
          <Flex>
            {
              isEdit_admissiondt ?
                <>
                  <DatePicker
                    value={temp_admissiondt ? dayjs(temp_admissiondt) : null}
                    placeholder="YYYY-MM-DD"
                    onChange={(date, dateString) => {
                      setTemp_admissiondt(dateString);
                    }}
                  />
                  <BtnSave onClick={async () => {
                    setIsEdit_admissiondt(false);
                    await loadAdmUpdatePreAuthForm(aid, {
                      "admissiondt": temp_admissiondt
                    });
                    await loadAdmGetPreAuthForm(aid);
                  }}>
                    <BtnSaveText>Save</BtnSaveText>
                  </BtnSave>
                  <BtnCancel title={"cancel"} onClick={async () => {
                    setIsEdit_admissiondt(false);
                    setTemp_admissiondt(data?.form?.admissiondt);
                  }}>
                    <BtnCancelText>Cancel</BtnCancelText>
                  </BtnCancel>
                </>
                :
                <>
                  <FormText>{data?.form?.admissiondt}</FormText>

                  {
                    !isCSTeam() &&
                    <BtnEdit title={"edit"} onClick={() => {
                      showSTPWarningModal(() => {
                        setIsEdit_admissiondt(true);
                      });
                    }}>
                      <Icon24 src={`${process.env.PUBLIC_URL}/images/pen.svg`} alt="edit" />
                    </BtnEdit>
                  }
                </>
            }
          </Flex>
        </Flex>

        <Flex direction={"column"} alignItems={"flex-start"}>
          <FormRemark>{t("translation:apply.step3_1.section3.f3")}</FormRemark>
          <Flex>
            {
              isEdit_hospital ?
                <Flex direction={"column"}>
                  <Flex>
                    <Select
                      optionFilterProp="label"
                      showSearch
                      options={hospitalList.map((item) => { return { value: item.hid, label: i18n.language === "ch" ? item.chi_name : item.eng_name } })}
                      value={temp_hospitalid}
                      onChange={(value) => {
                        setTemp_hospitalid(value);
                      }}
                      style={{
                        width: 300,
                      }}
                    />
                    <BtnSave onClick={async () => {
                      setIsEdit_hospital(false);
                      await loadAdmUpdatePreAuthForm(aid, {
                        "operationloctype": "HOSPITAL",
                        "location": "HKMU",
                        "hospitalid": temp_hospitalid
                      });
                      await loadAdmGetPreAuthForm(aid);
                    }}>
                      <BtnSaveText>Save</BtnSaveText>
                    </BtnSave>
                    <BtnCancel title={"cancel"} onClick={async () => {
                      setIsEdit_hospital(false);
                      setTemp_hospitalid(data?.form?.hospitalid);
                    }}>
                      <BtnCancelText>Cancel</BtnCancelText>
                    </BtnCancel>
                  </Flex>
                  <FormText>or</FormText>
                  <Flex>
                    <Input
                      value={temp_hospital}
                      style={{
                        width: 297,
                      }}
                      onChange={(e) => {
                        setTemp_hospital(e.target.value);
                      }}
                    />
                    <BtnSave onClick={async () => {
                      setIsEdit_hospital(false);
                      await loadAdmUpdatePreAuthForm(aid, {
                        "operationloctype": "HOSPITAL",
                        "location": "HKMU",
                        "hospitalid": "00000000000000000000000000000000",
                        "otherhopsital": temp_hospital,
                      });
                      await loadAdmGetPreAuthForm(aid);
                    }}>
                      <BtnSaveText>Save</BtnSaveText>
                    </BtnSave>
                    <BtnCancel title={"cancel"} onClick={async () => {
                      setIsEdit_hospital(false);
                      setTemp_hospital(data?.form?.hospital);
                    }}>
                      <BtnCancelText>Cancel</BtnCancelText>
                    </BtnCancel>
                  </Flex>
                </Flex>
                :
                <>
                  {
                    data?.form?.operationloctype === "HOSPITAL" && data?.form?.location === "HKMU" && data?.form?.hospitalid !== "00000000000000000000000000000000" && data?.form?.hospitalid !== null ?
                      <FormText>{hospitalList?.find(item => item.hid === data?.form?.hospitalid)[i18n.language === "ch" ? "chi_name" : "eng_name"]}</FormText>
                      :
                      <FormText>{data?.form?.hospital}</FormText>
                  }

                  {
                    !isCSTeam() &&
                    <BtnEdit title={"edit"} onClick={() => {
                      showSTPWarningModal(() => {
                        setIsEdit_hospital(true);
                      });
                    }}>
                      <Icon24 src={`${process.env.PUBLIC_URL}/images/pen.svg`} alt="edit" />
                    </BtnEdit>
                  }
                </>
            }
          </Flex>
        </Flex>

        <Flex direction={"column"} alignItems={"flex-start"}>
          <FormRemark>{t("translation:apply.step3_1.section3.f4")}</FormRemark>
          <Flex>
            {
              isEdit_housingclass ?
                <>
                  <Select
                    optionFilterProp="label"
                    options={[
                      {
                        label: t("translation:apply.step3_1.section3.f4_Option1"),
                        value: "REGULAR",
                      },
                      {
                        label: t("translation:apply.step3_1.section3.f4_Option2"),
                        value: "SEMI",
                      },
                      {
                        label: t("translation:apply.step3_1.section3.f4_Option3"),
                        value: "PRIVATE",
                      },
                      {
                        label: t("translation:apply.step3_1.section3.f4_Option4"),
                        value: "DAYCASE",
                      },
                      {
                        label: t("translation:apply.step3_1.section3.f4_Option5"),
                        value: "OUTPATIENT_CLINICAL",
                      },
                    ]}
                    value={temp_housingclass}
                    onChange={(value) => {
                      setTemp_housingclass(value);
                    }}
                    style={{
                      minWidth: 130,
                    }}
                  />
                  <BtnSave onClick={async () => {
                    setIsEdit_housingclass(false);
                    await loadAdmUpdatePreAuthForm(aid, {
                      "housingclass": temp_housingclass
                    });
                    await loadAdmGetPreAuthForm(aid);
                  }}>
                    <BtnSaveText>Save</BtnSaveText>
                  </BtnSave>
                  <BtnCancel title={"cancel"} onClick={async () => {
                    setIsEdit_housingclass(false);
                    setTemp_housingclass(data?.form?.housingclass);
                  }}>
                    <BtnCancelText>Cancel</BtnCancelText>
                  </BtnCancel>
                </>
                :
                <>
                  {data?.form?.housingclass === "REGULAR" && <FormText>{t("translation:apply.step3_1.section3.f4_Option1")}</FormText>}
                  {data?.form?.housingclass === "SEMI" && <FormText>{t("translation:apply.step3_1.section3.f4_Option2")}</FormText>}
                  {data?.form?.housingclass === "PRIVATE" && <FormText>{t("translation:apply.step3_1.section3.f4_Option3")}</FormText>}
                  {data?.form?.housingclass === "DAYCASE" && <FormText>{t("translation:apply.step3_1.section3.f4_Option4")}</FormText>}
                  {data?.form?.housingclass === "OUTPATIENT_CLINICAL" && <FormText>{t("translation:apply.step3_1.section3.f4_Option5")}</FormText>}

                  {
                    !isCSTeam() &&
                    <BtnEdit title={"edit"} onClick={() => {
                      showSTPWarningModal(() => {
                        setIsEdit_housingclass(true);
                      });
                    }}>
                      <Icon24 src={`${process.env.PUBLIC_URL}/images/pen.svg`} alt="edit" />
                    </BtnEdit>
                  }
                </>
            }
          </Flex>
        </Flex>

        <Flex direction={"column"} alignItems={"flex-start"}>
          <FormRemark>{t("translation:apply.step3_1.section3.f5")}</FormRemark>
          <Flex>
            {
              isEdit_diagnosis ?
                <>
                  <TextArea
                    value={temp_diagnosis}
                    placeholder={t("translation:apply.step3_1.section3.f5")}
                    autoSize={{ minRows: 3 }}
                    style={{ minWidth: 300 }}
                    onChange={(e) => {
                      setTemp_diagnosis(e.target.value);
                    }}
                  />
                  <BtnSave onClick={async () => {
                    setIsEdit_diagnosis(false);
                    await loadAdmUpdatePreAuthForm(aid, {
                      "diagnosis": temp_diagnosis
                    });
                    await loadAdmGetPreAuthForm(aid);
                  }}>
                    <BtnSaveText>Save</BtnSaveText>
                  </BtnSave>
                  <BtnCancel title={"cancel"} onClick={async () => {
                    setIsEdit_diagnosis(false);
                    setTemp_diagnosis(data?.form?.diagnosis);
                  }}>
                    <BtnCancelText>Cancel</BtnCancelText>
                  </BtnCancel>
                </>
                :
                <>
                  <FormText>{data?.form?.diagnosis}</FormText>

                  {
                    !isCSTeam() &&
                    <BtnEdit title={"edit"} onClick={() => {
                      showSTPWarningModal(() => {
                        setIsEdit_diagnosis(true);
                      });
                    }}>
                      <Icon24 src={`${process.env.PUBLIC_URL}/images/pen.svg`} alt="edit" />
                    </BtnEdit>
                  }
                </>
            }
          </Flex>
        </Flex>

        <Flex direction={"column"} alignItems={"flex-start"}>
          <FormRemark>{t("translation:apply.step3_1.section3.f6")}</FormRemark>
          <Flex>
            {
              isEdit_medsigndt ?
                <>
                  <DatePicker
                    value={temp_medsigndt ? dayjs(temp_medsigndt) : null}
                    placeholder="YYYY-MM-DD"
                    onChange={(date, dateString) => {
                      setTemp_medsigndt(dateString);
                    }}
                  />
                  <BtnSave onClick={async () => {
                    setIsEdit_medsigndt(false);
                    await loadAdmUpdatePreAuthForm(aid, {
                      "medsigndt": temp_medsigndt
                    });
                    await loadAdmGetPreAuthForm(aid);
                  }}>
                    <BtnSaveText>Save</BtnSaveText>
                  </BtnSave>
                  <BtnCancel title={"cancel"} onClick={async () => {
                    setIsEdit_medsigndt(false);
                    setTemp_medsigndt(data?.form?.medsigndt);
                  }}>
                    <BtnCancelText>Cancel</BtnCancelText>
                  </BtnCancel>
                </>
                :
                <>
                  <FormText>{data?.form?.medsigndt?.substr(0, 10)}</FormText>

                  {
                    !isCSTeam() &&
                    <BtnEdit title={"edit"} onClick={() => {
                      showSTPWarningModal(() => {
                        setIsEdit_medsigndt(true);
                      });
                    }}>
                      <Icon24 src={`${process.env.PUBLIC_URL}/images/pen.svg`} alt="edit" />
                    </BtnEdit>
                  }
                </>
            }
          </Flex>
        </Flex>

        <Flex direction={"column"} alignItems={"flex-start"}>
          <FormRemark>{t("translation:apply.step3_1.section3.f7")}</FormRemark>
          <Flex>
            {
              isEdit_Ansthsimthd ?
                <>
                  <Select
                    optionFilterProp="label"
                    options={[
                      {
                        label: t("translation:apply.step2_4.section2.Q9_Option1"),
                        value: "NONEED",
                      },
                      {
                        label: t("translation:apply.step2_4.section2.Q9_Option2"),
                        value: "PARTIAL",
                      },
                      {
                        label: t("translation:apply.step2_4.section2.Q9_Option3"),
                        value: "FULL",
                      },
                      {
                        label: t("translation:apply.step2_4.section2.Q9_Option4"),
                        value: "MONITOR",
                      },
                      {
                        label: t("translation:apply.step2_4.section2.Q9_Option5"),
                        value: "UNKNOWN",
                      },
                    ]}
                    value={temp_Ansthsimthd}
                    onChange={(value) => {
                      setTemp_Ansthsimthd(value);
                    }}
                    style={{
                      minWidth: 130,
                    }}
                  />
                  <BtnSave onClick={async () => {
                    setIsEdit_Ansthsimthd(false);
                    await loadAdmUpdatePreAuthForm(aid, {
                      "Ansthsimthd": temp_Ansthsimthd
                    });
                    await loadAdmGetPreAuthForm(aid);
                  }}>
                    <BtnSaveText>Save</BtnSaveText>
                  </BtnSave>
                  <BtnCancel title={"cancel"} onClick={async () => {
                    setIsEdit_Ansthsimthd(false);
                    setTemp_Ansthsimthd(data?.form?.Ansthsimthd);
                  }}>
                    <BtnCancelText>Cancel</BtnCancelText>
                  </BtnCancel>
                </>
                :
                <>
                  {data?.form?.Ansthsimthd === "NONEED" && <FormText>{t("translation:apply.step2_4.section2.Q9_Option1")}</FormText>}
                  {data?.form?.Ansthsimthd === "PARTIAL" && <FormText>{t("translation:apply.step2_4.section2.Q9_Option2")}</FormText>}
                  {data?.form?.Ansthsimthd === "FULL" && <FormText>{t("translation:apply.step2_4.section2.Q9_Option3")}</FormText>}
                  {data?.form?.Ansthsimthd === "MONITOR" && <FormText>{t("translation:apply.step2_4.section2.Q9_Option4")}</FormText>}
                  {data?.form?.Ansthsimthd === "UNKNOWN" && <FormText>{t("translation:apply.step2_4.section2.Q9_Option5")}</FormText>}

                  {
                    !isCSTeam() &&
                    <BtnEdit title={"edit"} onClick={() => {
                      showSTPWarningModal(() => {
                        setIsEdit_Ansthsimthd(true);
                      });
                    }}>
                      <Icon24 src={`${process.env.PUBLIC_URL}/images/pen.svg`} alt="edit" />
                    </BtnEdit>
                  }
                </>
            }
          </Flex>
        </Flex>

        <Flex direction={"column"} alignItems={"flex-start"}>
          <FormRemark>{t("translation:apply.step3_1.section3.f8")}</FormRemark>
          <Flex>
            {
              isEdit_oprtn ?
                <>
                  <TextArea
                    value={temp_oprtn}
                    placeholder={t("translation:apply.step3_1.section3.f8")}
                    autoSize={{ minRows: 3 }}
                    style={{ minWidth: 300 }}
                    onChange={(e) => {
                      setTemp_oprtn(e.target.value);
                    }}
                  />
                  <BtnSave onClick={async () => {
                    setIsEdit_oprtn(false);
                    await loadAdmUpdatePreAuthForm(aid, {
                      "oprtn": temp_oprtn
                    });
                    await loadAdmGetPreAuthForm(aid);
                  }}>
                    <BtnSaveText>Save</BtnSaveText>
                  </BtnSave>
                  <BtnCancel title={"cancel"} onClick={async () => {
                    setIsEdit_oprtn(false);
                    setTemp_oprtn(data?.form?.oprtn);
                  }}>
                    <BtnCancelText>Cancel</BtnCancelText>
                  </BtnCancel>
                </>
                :
                <>
                  <FormText>{data?.form?.oprtn}</FormText>

                  {
                    !isCSTeam() &&
                    <BtnEdit title={"edit"} onClick={() => {
                      showSTPWarningModal(() => {
                        setIsEdit_oprtn(true);
                      });
                    }}>
                      <Icon24 src={`${process.env.PUBLIC_URL}/images/pen.svg`} alt="edit" />
                    </BtnEdit>
                  }
                </>
            }
          </Flex>
        </Flex>
      </Flex>

      <FormTitle>{t("translation:apply.step3_1.section4.title").replace("4. ", "")}</FormTitle>
      <Flex direction={"column"} alignItems={"flex-start"} gap={0}>
        <Flex alignItems={"baseline"} >
          <FormText style={{ flex: 2, width: 300 }}>{t("translation:apply.step2_3.Q1")}</FormText>
          <Flex>
            <FormRemark style={{ fontSize: 12 }}>HK$</FormRemark>
            <Flex>
              {
                isEdit_surgeonfee ?
                  <>
                    <Input
                      value={temp_surgeonfee}
                      placeholder={t("translation:apply.step2_3.Q1")}
                      style={{ minWidth: 50 }}
                      type={"number"}
                      min={"0"}
                      onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()}
                      onChange={(e) => {
                        setTemp_surgeonfee(e.target.value);
                      }}
                    />
                    <BtnSave onClick={async () => {
                      setIsEdit_surgeonfee(false);
                      await loadAdmUpdatePreAuthForm(aid, {
                        "surgeonfee": temp_surgeonfee
                      });
                      await loadAdmGetPreAuthForm(aid);
                    }}>
                      <BtnSaveText>Save</BtnSaveText>
                    </BtnSave>
                    <BtnCancel title={"cancel"} onClick={async () => {
                      setIsEdit_surgeonfee(false);
                      setTemp_surgeonfee(data?.form?.surgeonfee);
                    }}>
                      <BtnCancelText>Cancel</BtnCancelText>
                    </BtnCancel>
                  </>
                  :
                  <>
                    <FormText style={{ fontSize: 16, lineHeight: "26px" }}>{formatCurrency(data?.form?.surgeonfee ?? 0)}</FormText>

                    {
                      !isCSTeam() &&
                      <BtnEdit title={"edit"} onClick={() => {
                        showSTPWarningModal(() => {
                          setIsEdit_surgeonfee(true);
                        });
                      }}>
                        <Icon24 src={`${process.env.PUBLIC_URL}/images/pen.svg`} alt="edit" />
                      </BtnEdit>
                    }
                  </>
              }
            </Flex>
          </Flex>
        </Flex>
        <Space height={16} />
        <Flex alignItems={"baseline"}>
          <FormText style={{ flex: 2, width: 300 }}>{t("translation:apply.step2_3.Q2")}</FormText>
          <FormRemark style={{ fontSize: 12 }}>HK$</FormRemark>
          <Flex>
            {
              isEdit_anesthesiologistfee ?
                <>
                  <Input
                    value={temp_anesthesiologistfee}
                    placeholder={t("translation:apply.step2_3.Q2")}
                    style={{ minWidth: 50 }}
                    type={"number"}
                    min={"0"}
                    onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()}
                    onChange={(e) => {
                      setTemp_anesthesiologistfee(e.target.value);
                    }}
                  />
                  <BtnSave onClick={async () => {
                    setIsEdit_anesthesiologistfee(false);
                    await loadAdmUpdatePreAuthForm(aid, {
                      "anesthesiologistfee": temp_anesthesiologistfee
                    });
                    await loadAdmGetPreAuthForm(aid);
                  }}>
                    <BtnSaveText>Save</BtnSaveText>
                  </BtnSave>
                  <BtnCancel title={"cancel"} onClick={async () => {
                    setIsEdit_anesthesiologistfee(false);
                    setTemp_anesthesiologistfee(data?.form?.anesthesiologistfee);
                  }}>
                    <BtnCancelText>Cancel</BtnCancelText>
                  </BtnCancel>
                </>
                :
                <>
                  <FormText style={{ fontSize: 16, lineHeight: "26px" }}>{formatCurrency(data?.form?.anesthesiologistfee ?? 0)}</FormText>

                  {
                    !isCSTeam() &&
                    <BtnEdit title={"edit"} onClick={() => {
                      showSTPWarningModal(() => {
                        setIsEdit_anesthesiologistfee(true);
                      });
                    }}>
                      <Icon24 src={`${process.env.PUBLIC_URL}/images/pen.svg`} alt="edit" />
                    </BtnEdit>
                  }
                </>
            }
          </Flex>
        </Flex>
        <Space height={16} />
        <Flex alignItems={"baseline"}>
          <FormText style={{ flex: 2, width: 300 }}>{t("translation:apply.step2_3.Q3")}</FormText>
          <FormRemark style={{ fontSize: 12 }}>HK$</FormRemark>
          <Flex>
            {
              isEdit_operatingrmfee ?
                <>
                  <Input
                    value={temp_operatingrmfee}
                    placeholder={t("translation:apply.step2_3.Q3")}
                    style={{ minWidth: 50 }}
                    type={"number"}
                    min={"0"}
                    onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()}
                    onChange={(e) => {
                      setTemp_operatingrmfee(e.target.value);
                    }}
                  />
                  <BtnSave onClick={async () => {
                    setIsEdit_operatingrmfee(false);
                    await loadAdmUpdatePreAuthForm(aid, {
                      "operatingrmfee": temp_operatingrmfee
                    });
                    await loadAdmGetPreAuthForm(aid);
                  }}>
                    <BtnSaveText>Save</BtnSaveText>
                  </BtnSave>
                  <BtnCancel title={"cancel"} onClick={async () => {
                    setIsEdit_operatingrmfee(false);
                    setTemp_operatingrmfee(data?.form?.operatingrmfee);
                  }}>
                    <BtnCancelText>Cancel</BtnCancelText>
                  </BtnCancel>
                </>
                :
                <>
                  <FormText style={{ fontSize: 16, lineHeight: "26px" }}>{formatCurrency(data?.form?.operatingrmfee ?? 0)}</FormText>

                  {
                    !isCSTeam() &&
                    <BtnEdit title={"edit"} onClick={() => {
                      showSTPWarningModal(() => {
                        setIsEdit_operatingrmfee(true);
                      });
                    }}>
                      <Icon24 src={`${process.env.PUBLIC_URL}/images/pen.svg`} alt="edit" />
                    </BtnEdit>
                  }
                </>
            }
          </Flex>
        </Flex>
        <Space height={16} />
        <Flex alignItems={"baseline"}>
          <FormText style={{ flex: 2, width: 300 }}>{t("translation:apply.step2_3.Q4")}</FormText>
          <FormRemark style={{ fontSize: 12 }}>HK$</FormRemark>
          <Flex>
            {
              isEdit_hosmisousfee ?
                <>
                  <Input
                    value={temp_hosmisousfee}
                    placeholder={t("translation:apply.step2_3.Q4")}
                    style={{ minWidth: 50 }}
                    type={"number"}
                    min={"0"}
                    onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()}
                    onChange={(e) => {
                      setTemp_hosmisousfee(e.target.value);
                    }}
                  />
                  <BtnSave onClick={async () => {
                    setIsEdit_hosmisousfee(false);
                    await loadAdmUpdatePreAuthForm(aid, {
                      "hosmisousfee": temp_hosmisousfee
                    });
                    await loadAdmGetPreAuthForm(aid);
                  }}>
                    <BtnSaveText>Save</BtnSaveText>
                  </BtnSave>
                  <BtnCancel title={"cancel"} onClick={async () => {
                    setIsEdit_hosmisousfee(false);
                    setTemp_hosmisousfee(data?.form?.hosmisousfee);
                  }}>
                    <BtnCancelText>Cancel</BtnCancelText>
                  </BtnCancel>
                </>
                :
                <>
                  <FormText style={{ fontSize: 16, lineHeight: "26px" }}>{formatCurrency(data?.form?.hosmisousfee ?? 0)}</FormText>

                  {
                    !isCSTeam() &&
                    <BtnEdit title={"edit"} onClick={() => {
                      showSTPWarningModal(() => {
                        setIsEdit_hosmisousfee(true);
                      });
                    }}>
                      <Icon24 src={`${process.env.PUBLIC_URL}/images/pen.svg`} alt="edit" />
                    </BtnEdit>
                  }
                </>
            }
          </Flex>
        </Flex>
        <Space height={16} />
        <Flex alignItems={"baseline"}>
          <FormText style={{ flex: 2, width: 300 }}>{t("translation:apply.step2_3.Q5")}</FormText>
          <FormRemark style={{ fontSize: 12 }}>HK$</FormRemark>
          <Flex>
            {
              isEdit_housetourfee ?
                <>
                  <Input
                    value={temp_housetourfee}
                    placeholder={t("translation:apply.step2_3.Q5")}
                    style={{ minWidth: 50 }}
                    type={"number"}
                    min={"0"}
                    onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()}
                    onChange={(e) => {
                      setTemp_housetourfee(e.target.value);
                    }}
                  />
                  <BtnSave onClick={async () => {
                    setIsEdit_housetourfee(false);
                    await loadAdmUpdatePreAuthForm(aid, {
                      "housetourfee": temp_housetourfee
                    });
                    await loadAdmGetPreAuthForm(aid);
                  }}>
                    <BtnSaveText>Save</BtnSaveText>
                  </BtnSave>
                  <BtnCancel title={"cancel"} onClick={async () => {
                    setIsEdit_housetourfee(false);
                    setTemp_housetourfee(data?.form?.housetourfee);
                  }}>
                    <BtnCancelText>Cancel</BtnCancelText>
                  </BtnCancel>
                </>
                :
                <>
                  <FormText style={{ fontSize: 16, lineHeight: "26px" }}>{formatCurrency(data?.form?.housetourfee ?? 0)}</FormText>

                  {
                    !isCSTeam() &&
                    <BtnEdit title={"edit"} onClick={() => {
                      showSTPWarningModal(() => {
                        setIsEdit_housetourfee(true);
                      });
                    }}>
                      <Icon24 src={`${process.env.PUBLIC_URL}/images/pen.svg`} alt="edit" />
                    </BtnEdit>
                  }
                </>
            }
          </Flex>
        </Flex>
        <Space height={16} />
        <Flex alignItems={"baseline"}>
          <FormText style={{ flex: 2, width: 300 }}>{t("translation:apply.step2_3.Q6")}</FormText>
          {/* <FormRemark style={{ fontSize: 12 }}>HK$</FormRemark> */}
          <Flex>
            {
              isEdit_noofdays ?
                <>
                  <Input
                    value={temp_noofdays}
                    placeholder={t("translation:apply.step2_3.Q6")}
                    style={{ minWidth: 50 }}
                    type={"number"}
                    min={"0"}
                    onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()}
                    onChange={(e) => {
                      setTemp_noofdays(e.target.value);
                    }}
                  />
                  <BtnSave onClick={async () => {
                    setIsEdit_noofdays(false);
                    await loadAdmUpdatePreAuthForm(aid, {
                      "noofdays": temp_noofdays
                    });
                    await loadAdmGetPreAuthForm(aid);
                  }}>
                    <BtnSaveText>Save</BtnSaveText>
                  </BtnSave>
                  <BtnCancel title={"cancel"} onClick={async () => {
                    setIsEdit_noofdays(false);
                    setTemp_noofdays(data?.form?.noofdays);
                  }}>
                    <BtnCancelText>Cancel</BtnCancelText>
                  </BtnCancel>
                </>
                :
                <>
                  <FormText style={{ fontSize: 16, lineHeight: "26px" }}>{data?.form?.noofdays ?? 0} <FormRemark>Days</FormRemark></FormText>

                  {
                    !isCSTeam() &&
                    <BtnEdit title={"edit"} onClick={() => {
                      showSTPWarningModal(() => {
                        setIsEdit_noofdays(true);
                      });
                    }}>
                      <Icon24 src={`${process.env.PUBLIC_URL}/images/pen.svg`} alt="edit" />
                    </BtnEdit>
                  }
                </>
            }
          </Flex>
        </Flex>
      </Flex>

      <Divider style={{ width: 450, margin: 0 }} />
      <Flex alignItems={"baseline"}>
        <FormText style={{ flex: 2, fontWeight: "bold", width: 300 }}>{t("translation:apply.step3_1.section4.total")}</FormText>
        <FormRemark style={{ fontSize: 12 }}>HK$</FormRemark>
        <FormText style={{ fontSize: 16, lineHeight: "26px" }}>{formatCurrency(parseFloat(data?.form?.surgeonfee ?? 0) + (parseFloat(data?.form?.anesthesiologistfee ?? 0)) + (parseFloat(data?.form?.operatingrmfee ?? 0)) + (parseFloat(data?.form?.hosmisousfee ?? 0)) + (((parseFloat(data?.form?.housetourfee ?? 0))) * (parseFloat(data?.form?.noofdays ?? 0))))}</FormText>
      </Flex>

      <Flex direction={"column"} alignItems={"flex-start"} style={{ gap: 10 }}>
        <FormRemark>Remark</FormRemark>
        <Flex>
          {
            isEdit_surgeryBudgetRemark ?
              <>
                <TextArea
                  value={temp_surgeryBudgetRemark}
                  placeholder={"Remark"}
                  autoSize={{ minRows: 3 }}
                  style={{ minWidth: 300 }}
                  onChange={(e) => {
                    setTemp_surgeryBudgetRemark(e.target.value);
                  }}
                />
                <BtnSave onClick={async () => {
                  setIsEdit_surgeryBudgetRemark(false);
                  await loadAdmUpdatePreAuthForm(aid, {
                    "surgeryBudgetRemark": temp_surgeryBudgetRemark
                  });
                  await loadAdmGetPreAuthForm(aid);
                }}>
                  <BtnSaveText>Save</BtnSaveText>
                </BtnSave>
                <BtnCancel title={"cancel"} onClick={async () => {
                  setIsEdit_surgeryBudgetRemark(false);
                  setTemp_surgeryBudgetRemark(data?.form?.surgeryBudgetRemark);
                }}>
                  <BtnCancelText>Cancel</BtnCancelText>
                </BtnCancel>
              </>
              :
              <>
                <FormText>{data?.form?.surgeryBudgetRemark}</FormText>

                {
                  !isCSTeam() &&
                  <BtnEdit title={"edit"} onClick={() => {
                    showSTPWarningModal(() => {
                      setIsEdit_surgeryBudgetRemark(true);
                    });
                  }}>
                    <Icon24 src={`${process.env.PUBLIC_URL}/images/pen.svg`} alt="edit" />
                  </BtnEdit>
                }
              </>
          }
        </Flex>
      </Flex>

      <FormTitle style={{ fontSize: 20, lineHeight: "30px" }}>Change Log</FormTitle>
      <Flex gap={16} direction={"column"} alignItems={"flex-start"}>
        {
          data?.log?.map((item) => {
            return <Flex gap={5} direction={"column"} alignItems={"flex-start"} key={item.logid}>
              <Flex gap={16}>
                <Log>{(item.fieldname !== "UPLDSUPPLEATTACHID" && item.fieldname !== "DELSUPPLEATTACHID") && `${t(`translation:admin.log.change`)} `}{t(`translation:admin.log.${item.fieldname}`)}</Log>
                {item.staffName && <LogModby>{item.staffName}</LogModby>}
                <LogDatetime>{item.updatetime.replace("T", " ")}</LogDatetime>
              </Flex>

              <Flex gap={16}>
                {
                  (item.fieldname === "UPLDSUPPLEATTACHID" || item.fieldname === "DELSUPPLEATTACHID") ?
                    <>
                      <Flex direction={"column"} alignItems={"flex-start"}>
                        <Log style={{ textDecoration: "underline" }}>Filename:</Log>
                      </Flex>
                      <Flex direction={"column"} alignItems={"flex-start"}>
                        <Log>{item.prevalue}</Log>
                      </Flex>
                    </>
                    :
                    <>
                      <Flex direction={"column"} alignItems={"flex-start"}>
                        <Log style={{ textDecoration: "underline" }}>From:</Log>
                        <Log style={{ textDecoration: "underline" }}>To:</Log>
                      </Flex>
                      <Flex direction={"column"} alignItems={"flex-start"}>
                        <Log>{getLogValueTranslation(item.fieldname, item.prevalue) ?? "N/A"}</Log>
                        <Log>{getLogValueTranslation(item.fieldname, item.postvalue)}</Log>
                      </Flex>
                    </>
                }
              </Flex>
            </Flex>
          })
        }

        {
          data?.log?.length === 0 && <Log>No Change Log</Log>
        }
      </Flex>
    </Flex>
  );
}

const BtnEdit = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
`;

const BtnSave = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
`;

const BtnSaveText = styled(FormText)`
  text-decoration: underline;
  color: var(--aia-bx-blue-6);
  width: 40px;
`;

const BtnCancel = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
`;

const BtnCancelText = styled(FormText)`
  text-decoration: underline;
  color: var(--aia-bx-gray-3);
  width: 40px;
`;

const Icon24 = styled.img`
  width: 24px;
  height: 24px;
`;

const Log = styled(FormText)`
  color: var(--aia-bx-light-black);
  font-size: 12px;
  line-height: 18px;
  font-weight: bold;
`;

const LogModby = styled(FormRemark)`
  font-size: 12px;
  line-height: 18px;
`;

const LogDatetime = styled(FormRemark)`
  font-size: 12px;
  line-height: 18px;
`;

export default Details;